import React from 'react';
import { Space } from 'antd';
import AccountSettings from '../components/AccountSettings';

const Settings: React.FC = () => (
  <div>
    <Space
      size="large"
      direction="horizontal"
      css={`
        width: 100%;
      `}
    >
      <AccountSettings />
    </Space>
  </div>
);

export default Settings;
